module.exports = __webpack_public_path__ + "media/images/presta_busc/neurologo-c0160f8c68f07cd332ecaabb1da21713.svg";